import React, { useState, useEffect } from 'react';
import styles from './chatFeedback.module.scss';

interface ChatFeedbackProps {
    caseId: string;
    feedbackSent: boolean;
    feedbackLiked: boolean | null;
    onSendFeedback: (caseId: string, liked: boolean) => void;
}

const ChatFeedback: React.FC<ChatFeedbackProps> = ({ caseId, feedbackSent, feedbackLiked, onSendFeedback }) => {
    const [hidden, setHidden] = useState(false);
    const [dismissing, setDismissing] = useState(false);

    useEffect(() => {
        if (feedbackSent && !hidden) {
            const timer = setTimeout(() => {
                setDismissing(true);
                setTimeout(() => setHidden(true), 350);
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [feedbackSent]);

    if (hidden) return null;

    if (feedbackSent) {
        return (
            <div className={`${styles.feedbackTab} ${dismissing ? styles.slideUp : ''}`}>
                <span className={styles.thankYou}>
                    {feedbackLiked ? '👍 ' : '👎 '} Gracias por tu feedback
                </span>
            </div>
        );
    }

    return (
        <div className={styles.feedbackTab}>
            <span className={styles.feedbackLabel}>¿Te está siendo útil esta conversación?</span>
            <div className={styles.feedbackButtons}>
                <button
                    className={styles.feedbackBtn}
                    onClick={() => onSendFeedback(caseId, true)}
                    aria-label="Me gusta"
                >
                    👍
                </button>
                <button
                    className={styles.feedbackBtn}
                    onClick={() => onSendFeedback(caseId, false)}
                    aria-label="No me gusta"
                >
                    👎
                </button>
            </div>
        </div>
    );
};

export default ChatFeedback;
